export default {
  getBoard(state) {
    return state.board;
  }
}
